import { breakpoints, subscribeToResize } from '@msc-b2c/shared-utils';

let cleanupLanguageNavigationResize: (() => void) | null = null;

function initSearchBar() {
  let searchInput: HTMLInputElement | null;
  if (window.innerWidth >= breakpoints.lg) {
    searchInput = document.querySelector('#lang-selector .language-search input');
  } else {
    searchInput = document.querySelector('#languageNavigator .language-search input');
  }

  //TODO: DELETE when new implementation of language switcher finish -- START
  let languageSwitcher: HTMLInputElement | null;

  if (window.innerWidth >= breakpoints.lg) {
    languageSwitcher = document.querySelector('#lang-selector');
  } else {
    languageSwitcher = document.querySelector('#languageNavigator');
  }

  if (languageSwitcher) {
    const allButtons = languageSwitcher.querySelectorAll<HTMLAnchorElement>('.button a');
    const swissButtons = Array.from(allButtons).filter((btn) => {
      const href = btn.getAttribute('href') || '';
      return href.includes('msccruises.ch');
    });

    swissButtons.forEach((button: HTMLAnchorElement) => {
      const href = button.getAttribute('href');

      if (!href) return;
      if (href.includes('/fr')) {
        const altLink = document.querySelector('link[hreflang="fr-CH"]');
        button.setAttribute('href', altLink?.getAttribute('href') || href);
      } else {
        const altLink = document.querySelector('link[hreflang="de-CH"]');
        button.setAttribute('href', altLink?.getAttribute('href') || href);
      }
    });
  }
  // --END

  const buttonContainers = document.querySelectorAll(
    '.language__modal .button:not(.-desktop-hide)'
  );
  const teaserContainers = document.querySelectorAll('.language__modal .teaser');

  if (!(searchInput instanceof HTMLInputElement)) return;

  // Attach event listener for live search
  searchInput.addEventListener('input', () => {
    const searchTerm = searchInput.value.toLowerCase();

    // Search in button containers
    buttonContainers.forEach((container) => {
      const span = container.querySelector('.cmp-button__text');
      if (span instanceof HTMLElement) {
        const textContent = span.textContent?.toLowerCase() ?? '';

        // Show or hide based on search term match
        if (textContent.includes(searchTerm)) {
          container.classList.remove('hide');
        } else {
          container.classList.add('hide');
        }
      }
    });

    // Search in teaser containers
    teaserContainers.forEach((container) => {
      const title = container.querySelector('.cmp-teaser__title');
      const pretitle = container.querySelector('.cmp-teaser__pretitle');

      if (title instanceof HTMLElement || pretitle instanceof HTMLElement) {
        const titleText = title?.textContent?.toLowerCase() ?? '';
        const pretitleText = pretitle?.textContent?.toLowerCase() ?? '';
        const combinedText = `${pretitleText} ${titleText}`;

        // Show or hide based on search term match in either title or pretitle
        if (combinedText.includes(searchTerm)) {
          container.classList.remove('hide');
        } else {
          container.classList.add('hide');
        }
      }
    });
  });

  const languageSwitchButton = document.querySelectorAll('.cmp-languagenavigation__item-link');
  languageSwitchButton.forEach((a) =>
    a.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.href = `${a.getAttribute('href')}${window.location.search}`;
    })
  );
}

async function onDocumentReady(): Promise<void> {
  initSearchBar();
}

export function initLanguageNavigation(): void {
  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
}

cleanupLanguageNavigationResize = subscribeToResize(() => {
  const hasLanguageSwitcher =
    document.querySelector('#lang-selector') || document.querySelector('#languageNavigator');
  if (!hasLanguageSwitcher) {
    cleanupLanguageNavigationResize?.();
    cleanupLanguageNavigationResize = null;
    return;
  }
  initSearchBar();
});

initLanguageNavigation();
